import { useEffect, useState } from 'react';

// The phone save bars are fixed to the bottom, where the on-screen keyboard
// lands. This is how far to lift them so Save stays above it.
export const useKeyboardInset = () => {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const update = () => {
      const hidden = window.innerHeight - viewport.height - viewport.offsetTop;
      setInset(Math.max(0, Math.round(hidden)));
    };

    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
    };
  }, []);

  return inset;
};
